import { MANAGED_SERVICE_KEY } from '../constants/user.constants'

const setManagedService = managedService => {
    localStorage.setItem(MANAGED_SERVICE_KEY, JSON.stringify(managedService))
}

const getManagedService = () => {
    var managedService = localStorage.getItem(MANAGED_SERVICE_KEY)
    return JSON.parse(managedService ?? null)
}

const clearManagedService = () => {
    localStorage.removeItem(MANAGED_SERVICE_KEY)
}

export const userService = {
    setManagedService,
    getManagedService,
    clearManagedService,
}
